module.exports = __webpack_public_path__ + "img/table-filter.41894237.svg";